import React from 'react';

import { Tooltip } from 'antd';

import TcpBadge from 'assets/member/tcp-badge.png';

const TcpProductIcon = () => {
  return (
    <Tooltip title='TCP Product' placement='top'>
      <span style={{ display: 'inline-flex', zIndex: 30 }}>
        <img
          src={TcpBadge}
          alt='TCP Product'
          style={{ width: 19, height: 19, objectFit: 'contain' }}
        />
      </span>
    </Tooltip>
  );
};

export default TcpProductIcon;
